const logger = process.env.TEST ? console : {
  log: () => {},
}


/**
 * Assigns the canonical baseProduct and information
 * @param {Array} products the incoming products (ie cart)
 * @param {Array} dbProducts the database (canonical) products
 * @param {Array} bps the required baseProducts from database
 * @return {Array} a list of products with the proper baseProduct key
 */
const assignBpsToProducts = (products, dbProducts, bps) => {
  try {
    const new_products = products.map((product) => {
      const dbProduct = dbProducts
        .find((p) => String(p._id) === (String(product.id || product._id)))
      if (!dbProduct) {
        throw new Error('product not found in db')
      }
      // NOTE manage delivery prices
      if (dbProduct.deliveryPrices && dbProduct.deliveryPrices.length) {
        // eslint-disable-next-line
        product.deliveryPrices = dbProduct.deliveryPrices
      }
      const dbBp = bps.find((bp) => String(dbProduct.supplierBaseProductId) === String(bp._id))
      // NOTE the new base Product
      const baseProduct = { ...dbBp, ...(dbProduct.baseProduct || {}) }
      // TODO trim unrequired keys
      // NOTE if it doesn't exist, we return the product as is
      if (!baseProduct || !(Object.keys(baseProduct).length)) return product
      return {
        ...product,
        baseProduct,
        stock: dbProduct.stock,
      }
    })
    return new_products
  } catch (e) {
    logger.log('assignBpsToProducts', e)
    return products
  }
}


module.exports = assignBpsToProducts
